import { render } from "./RunAiProcessModal.vue?vue&type=template&id=6baead9f"
import script from "./RunAiProcessModal.vue?vue&type=script&lang=js"
export * from "./RunAiProcessModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__